const emailDropDownData = {
  onAddPost: "On Creation",
  onTitleDescChange: "On Title/Desc Change",
  onAssigneeChange: "On Assignee Change",
  onDueDateChange: "On Due date Change",
  onStatusChange: "On Completion",
  onAddComment: "On Add Comment",
};

export { emailDropDownData };
